// Reimplemented from eb-ui packages/attendee/trending/src/components/TimeframeNavList.tsx.
// eb-ui rendered an EDS `NavList` (displayInline) of ANCHOR_LINK items with an
// `active` flag + onClick. `@eventbrite/eds-nav-list` has no react-19 Valkyrie home,
// so we render the same thing as a plain inline nav: 4 timeframe buttons, the active
// one highlighted (the eb-ui `.active` treatment), click switches timeframe. Buttons
// (not anchors) because switching does not navigate — it re-fetches in place.

import React from 'react';
import { Timeframe } from '../types';
import { timeframesMap } from '../utils';

interface TimeframeNavListProps {
    activeTimeframe: string;
    location: string;
    onSelect: (timeframe: Timeframe, location: string) => void;
}

const TimeframeNavList = ({ activeTimeframe, location, onSelect }: TimeframeNavListProps) => (
    <div id="timeframe-nav-list">
        <ul className="trending-timeframe-nav">
            {(Object.keys(timeframesMap) as Timeframe[]).map((key) => {
                const isActive = activeTimeframe === key;
                return (
                    <li key={key} className="trending-timeframe-nav__item">
                        <button
                            type="button"
                            className={`trending-timeframe-nav__link${isActive ? ' active' : ''}`}
                            aria-current={isActive ? 'true' : undefined}
                            onClick={() => onSelect(key, location)}
                        >
                            {timeframesMap[key]}
                        </button>
                    </li>
                );
            })}
        </ul>
    </div>
);

export default TimeframeNavList;
